import React, { useMemo, useRef, useState } from "react";
import { Select, Spin } from "antd";
import debounce from "lodash/debounce";
import { getCookie } from "shared/utils/cookies";

const GlobalTicketSearch = ({
  fetchTickets,
  placeholder = "Search by summary or ticket ID",
  style = { width: "100%" }
}) => {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(null);
  const fetchRef = useRef(0);

  const debounceFetcher = useMemo(() => {
    const loadOptions = (searchValue) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      setFetching(true);
      setOptions([]);

      fetchTickets({ search: searchValue }).then((res = {}) => {
        if (fetchId !== fetchRef.current) return;

        const tickets = Array.isArray(res?.tickets) ? res.tickets : [];

        setOptions(
          tickets.map(ticket => ({
            key: ticket.ticketId,
            label: ticket.summary,
            value: ticket.ticketId,
            ticketCode: ticket.ticketId,
            workspaceId: ticket.workspace,
            summary: ticket.summary
          }))
        );

        setFetching(false);
      });
    };

    return debounce(loadOptions, 300);
  }, [fetchTickets]);

  const handleChange = (selectedValue) => {
   

    const { workspaceId, ticketCode } = selectedValue;
    const accountId = getCookie("accountId");

    window.open(
      `/open/ticket/${accountId}/${workspaceId}/${ticketCode}`,
      "_blank"
    );

    setValue(null);
  };

  return (
    <Select
      showSearch
      allowClear
      value={value}
      filterOption={false}
      placeholder={placeholder}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : "No tickets found"}
      options={options}
      style={style}
      optionRender={(option) => (
        <div onClick={()=>handleChange(option.data)}>
          <strong>{option.data.ticketCode}</strong>
          <div style={{ fontSize: 12, color: "#888" }}>
            {option.data.summary}
          </div>
        </div>
      )}
    />
  );
};

export default GlobalTicketSearch;
